import React, {Component} from 'react';


export default class Video extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <figure className="video">
                <div className="img-flow ratio-16-9">
                    {this.props.localVideoUrl &&
                        <video controls poster={this.props.imageUrl} src={this.props.localVideoUrl}></video>
                    }
                    {!this.props.localVideoUrl && this.props.embedCode &&
                        <div dangerouslySetInnerHTML={{__html: this.props.embedCode}}/>
                    }
                </div>
            </figure>
        );
    }
}
